// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VbpqA","clinicsSelect":"styles_clinicsSelect__d_pkv"};